import { Breadcrumbs } from "../components/global/Breadcrumbs"
import { OurStory } from "../components/about/OurStory"
import { Stats } from "../components/about/Stats"
import { TeamCarousel } from "../components/about/TeamCarousel"
import { FeaturesSection } from "../components/homepage/FeaturesSection"
import "./about.css"

export function About() {
    return (
        <div className="about mx-auto overflow-hidden">

            <div className="about-1 mx-auto">
                <Breadcrumbs dynamicPath="About" />
                <OurStory />
            </div>
            
            <Stats />

            <div className="about-2 mx-auto">
                <TeamCarousel />
                <FeaturesSection />
            </div>

        </div>
    )
}